import { Button } from '@mui/material';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Document, Page, pdfjs } from 'react-pdf';
import { useParams } from 'react-router-dom';

import { getLink } from '../../Common/Database';
import Loader from '../../Components/Loader';
import { throwErrorRollbar } from '../../index';

import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import './style.scss';

function PublicMaterial() {
  const [pageNumber, setPageNumber] = useState(1);
  const [inputPageNumber, setInputPageNumber] = useState(pageNumber.toString());
  const [prevPageNumber, setPrevPageNumber] = useState(pageNumber);
  const [isLoading, setIsLoading] = useState(true);
  const [numPages, setNumPages] = useState();
  const [url, setUrl] = useState();
  const [type, setType] = useState();

  const params = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    let interval = null;

    getLink(params.id)
      .then(snapshot => {
        if (snapshot.exists()) {
          const linkInfo = snapshot.val();
          const expireAt = new Date(linkInfo.expireAt);
          const isPermanent = linkInfo.permanent;

          if (isPermanent || new Date() < expireAt) {
            setUrl(linkInfo.url);
            setPageNumber(linkInfo.pageNum);
            setType(linkInfo.type);

            if (!isPermanent) {
              interval = setInterval(() => {
                if (new Date() >= expireAt) {
                  setUrl(null);
                }
              }, 1000);
            }
          }
        }
      })
      .catch(error => {
        console.error(error);
        throwErrorRollbar(error);
      })
      .finally(() => {
        setIsLoading(false);
      });

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [params.id]);

  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const onPageNumInputChange = e => {
    const inputVal = e.target.value;
    const pattern = /^\d*$/;

    if (pattern.test(inputVal)) {
      setInputPageNumber(inputVal);

      const pageNum = parseInt(inputVal);

      if (!isNaN(pageNum)) {
        setPageNumber(Math.min(Math.max(1, pageNum), numPages));
        setPrevPageNumber(pageNum);
      }
    } else {
      setInputPageNumber(prevPageNumber.toString());
    }
  };

  useEffect(() => {
    setInputPageNumber(pageNumber.toString());
  }, [pageNumber]);

  return (
    <div className="material-view-page material-public-page container">
      <div className="material-view_content">
        <div className="lesson-panel-wrap">
          <div className="btn-wrap">
            <Button
              disabled={pageNumber <= 1}
              onClick={() => {
                setPageNumber(pageNumber - 1);
              }}
              variant="contained"
              className="btn btn-icon btn-left"
            >
              <span className="icon icon-chevron-left"></span>
            </Button>
          </div>

          <div className="lesson-panel">
            {isLoading ? (
              <Loader />
            ) : type !== 'Picture' ? (
              <Document className="doc" loading={<Loader />} file={url} onLoadSuccess={onDocumentLoadSuccess}>
                <Page className="doc-page" pageNumber={pageNumber} />
              </Document>
            ) : (
              <img src={url} alt="" />
            )}
          </div>

          <Button
            disabled={pageNumber >= numPages}
            onClick={() => {
              setPageNumber(pageNumber + 1);
            }}
            variant="contained"
            className="btn btn-icon btn-right"
          >
            <span className="icon icon-chevron-right"></span>
          </Button>
        </div>

        {!isLoading && type !== 'Picture' && (
          <div className="pagination">
            <div className="page-number">
              {t('page')}{' '}
              <input
                type="text"
                className="page-input"
                value={inputPageNumber}
                onChange={onPageNumInputChange}
                pattern="\d*"
              />{' '}
              {t('from')} {numPages || '--'}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PublicMaterial;
